import { MetricCardProps } from '../types';
import { Box, Paper, Stack, alpha, Skeleton, useTheme, Typography } from '@mui/material';

const MetricCard = ({ icon, title, value, helper, tone, loading, href }: MetricCardProps) => {
  const theme = useTheme();
  const color = theme.palette[tone].main;

  return (
    <Paper
      component={href ? 'a' : 'div'}
      href={href}
      target={href ? '_blank' : undefined}
      rel={href ? 'noopener noreferrer' : undefined}
      elevation={0}
      sx={{
        display: 'block',
        p: 2,
        height: '100%',
        border: '1px solid',
        borderColor: alpha(color, theme.palette.mode === 'dark' ? 0.32 : 0.22),
        borderRadius: '8px',
        bgcolor: alpha(color, theme.palette.mode === 'dark' ? 0.12 : 0.055),
        color: 'inherit',
        textDecoration: 'none',
        transition: 'border-color 0.2s ease, background-color 0.2s ease',
        ...(href && {
          '&:hover': {
            borderColor: alpha(color, 0.5),
            bgcolor: alpha(color, theme.palette.mode === 'dark' ? 0.18 : 0.09),
          },
          '&:focus-visible': {
            outline: `2px solid ${color}`,
            outlineOffset: 2,
          },
        }),
      }}>
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box
          sx={{
            width: 42,
            height: 42,
            display: 'grid',
            flexShrink: 0,
            placeItems: 'center',
            color,
            borderRadius: '8px',
            bgcolor: alpha(color, theme.palette.mode === 'dark' ? 0.18 : 0.12),
            '& .MuiSvgIcon-root': { fontSize: 22 },
          }}>
          {icon}
        </Box>

        <Box sx={{ minWidth: 0 }}>
          <Typography variant="body2" color="text.secondary" noWrap>
            {title}
          </Typography>
          {loading ? (
            <Skeleton width={64} height={34} />
          ) : (
            <Typography variant="h5" sx={{ fontWeight: 800, lineHeight: 1.2 }}>
              {value}
            </Typography>
          )}
          <Typography variant="caption" color="text.secondary" noWrap>
            {helper}
          </Typography>
        </Box>
      </Stack>
    </Paper>
  );
};

export default MetricCard;
